<template>
  <v-list-item v-on="hasClickListener ? { click: () => $emit('click') } : {}">
    <slot name="icon"></slot>
    <v-list-item-content>
      <v-list-item-title>
        <a v-if="hasOpenDetailListener" @click.stop="emitOpenDetail"> {{ item.companyName }} </a>
        <div v-else>{{ item.companyName }}</div>
      </v-list-item-title>
      <v-list-item-subtitle> {{ item.companyUsername }} {{ item.id }} </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { GoToHelper } from "@/lib/utility/goToHelper";
import { ThgPartnerViewModelGen } from "@/services/thg/v1/data-contracts";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";

@Component({
  components: {},
  filters: {}
})
export default class RefsPartner extends BaseRef<ThgPartnerViewModelGen> implements IRefDetail<ThgPartnerViewModelGen> {
  @Prop()
  item!: ThgPartnerViewModelGen;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  goToDetail() {
    new GoToHelper(this.$router).goToPartnerDetail(PartnerModule.partner.id, true);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }
}
</script>
